<template>
	<div
	class="employment"
		:class="{active: id === employeeActive}"
		@click="sendValue(title, id)"
	>
		<img :src="icon" alt="" height="19px">
		<span class="title-name">{{title}}</span>
	</div>
</template>
<script>
function sendValue(employ, id) {
	this.activeEmployement = id;
	this.$emit('selected-employ', employ, id);
}

function data() {
	return {
		active: false,
	};
}

export default {
	name: 'employment-component',
	data,
	methods: {
		sendValue,
	},
	props: {
		employeeActive: {
			type: [Number, String],
		},
		icon: {
			default: 'person',
			type: String,
		},
		name: {
			default: 'dueño',
			type: String,
		},
		title: {
			default: 'Dueńo',
			type: String,
		},
		id: {
			default: 'idCharge',
			type: Number,
		},
	},
};
</script>

<style lang="scss" scoped>
.title-name {
	margin-top: 5px;
}

.employment {
	align-items: center;
	background-color: white;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
	color: map-get($colors, header-icons);
	display: flex;
	flex-direction: column;
	font-size: map-get($sizes, twelve);
	height: 67px;
	justify-content: center;
	transform: scale(1);
	width: 105px;
}

.employment:hover {
	box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
	transform: scale(1.01);
}

.active {
	background-color: map-get($colors, button-planning);
	color: white;
}
</style>




// WEBPACK FOOTER //
// EmploymentComponent.vue?188b1401